

export  {rentals}




    const rentals = [
        {
            name: "Marée Haute",
            location: "Saint-Vincent-Sur-Jard",
            details: "1 Chambre | 2 Hôtes",
            imageUrl: "./assets/imageGites/MH.webp",
            link: "/#/haute",
            title: "photo de Marée haute git " // Titre associé à l'image
        },
        {
            name: "Étale",
            location: "Saint-Vincent-Sur-Jard",
            details: "3 Chambres | 6 Hôtes",
            imageUrl: "./assets/imageGites/etale.webp",
            link: "/#/etale",
            title: "photo de Étale git a louer" // Titre associé à l'image
        },
        {
            name: "Marée Basse",
            location: "Saint-Vincent-Sur-Jard",
            details: "1 Chambre  | 4 Hôtes",
            imageUrl: "./assets/imageGites/MB.webp",
            link: "/#/basse",
            title: "photo de Marée basse git a louer " // Titre associé à l'image
        }
    ];
    

export default rentals;
